import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { eurUnit, pct } from "@/lib/format";
import { t, locale } from "@/i18n";

const axis = { stroke: "hsl(var(--muted-foreground))", fontSize: 11, tickLine: false, axisLine: false };

function Tip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const p = payload[0].payload;
  return (
    <div className="rounded-lg border bg-popover/90 px-3 py-2 text-xs shadow-lg backdrop-blur-md">
      <p className="font-semibold">{p.label}</p>
      <p className="text-muted-foreground">{p.supplier || "—"}</p>
      <p className="num mt-1 font-semibold">{eurUnit(p.unit_cost)}</p>
    </div>
  );
}

export default function PriceHistoryChart({ history, unit }) {
  const data = [...history].sort((a, b) => a.date.localeCompare(b.date))
    .map((h) => ({ ...h, label: new Date(h.date).toLocaleDateString(locale, { day: "2-digit", month: "short", year: "2-digit" }) }));
  if (data.length < 2) return <p className="rounded-lg border border-dashed p-4 text-center text-xs text-muted-foreground" data-testid="price-chart-empty">{t("priceHistoryChart.au_moins_deux_prix_sont_necessaires_pour_t")}</p>;
  const first = data[0].unit_cost, last = data[data.length - 1].unit_cost;
  const change = first ? ((last - first) / first) * 100 : 0;
  const color = change > 15 ? "#F43F5E" : change >= 5 ? "#F59E0B" : "#10B981";

  return (
    <div data-testid="ingredient-price-chart">
      <div className="mb-2 flex items-baseline justify-between">
        <p className="eyebrow">{t("priceHistoryChart.evolution_du_prix")}{unit})</p>
        <p className="num text-sm font-semibold" style={{ color }} data-testid="price-chart-change">{pct(change, true)}</p>
      </div>
      <div className="h-44 rounded-lg border bg-background/40 p-2">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ left: -8, right: 8, top: 8, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
            <XAxis dataKey="label" {...axis} minTickGap={16} />
            <YAxis {...axis} domain={["auto", "auto"]} allowDecimals tickCount={5} tickFormatter={(v) => Number(v).toLocaleString(locale, { maximumFractionDigits: 2 })} width={48} />
            <Tooltip content={<Tip />} />
            <Line type="monotone" dataKey="unit_cost" stroke={color} strokeWidth={2.2} dot={{ r: 3, fill: color }} activeDot={{ r: 5 }} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
